import { useAdmin, usePermissions, useUser } from '@/utils/hooks'

interface PermissionsRequiredProps {
  permissions?: string | string[]
  permissionsIfMe?: [userId: string, ...permissions: string[]]
  ignoreAdmin?: boolean
}

export const PermissionsRequired: React.JSX.CFC<PermissionsRequiredProps> = ({
  children,
  permissions,
  permissionsIfMe,
  ignoreAdmin = false,
}) => {
  const me = useUser()
  const admin = useAdmin()
  const { hasPermissions } = usePermissions()

  if (
    typeof permissions === 'undefined' &&
    typeof permissionsIfMe === 'undefined'
  )
    return <>{children}</>
  if (typeof permissions === 'string') permissions = [permissions]

  if (!ignoreAdmin && admin) return <>{children}</>

  if (!!permissionsIfMe && me.id === permissionsIfMe[0]) {
    const perms = permissionsIfMe.slice(1)
    if (!hasPermissions(perms)) return null
  } else if (!hasPermissions(permissions ?? [])) return null

  return <>{children}</>
}
